/**
 * 営業担当者の表示名を生成する
 * 形式: 名前(電話番号)
 */
export const advisorDisplay = (name: string | null, phone: string | null): string => {
  const displayName = name ?? '不明';
  const displayPhone = phone ?? '不明';
  return `${displayName}(${displayPhone})`;
};
